export enum OfferState {
	WaitingForManualOffer = 0,
	WaitingForCustomerAnswer = 1,
	Accepted = 2,
	Declined = 3,
}
